import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var _excluded = ["component"];
var DEFAULT_LINK_TYPE = 'a';
var LinkProviderContext = /*#__PURE__*/React.createContext(DEFAULT_LINK_TYPE);
var LinkProvider = _ref => {
  var {
      component
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LinkProviderContext.Provider, _extends({
    value: component
  }, rest));
};
LinkProvider.propTypes = {
  /** The component/element pattern library components (and LinkGenerator) should use for links */
  component: PropTypes.elementType.isRequired
};

export { DEFAULT_LINK_TYPE, LinkProvider, LinkProviderContext };
//# sourceMappingURL=index.js.map
